import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  clientId: Yup.string().required("Client is required"),
  key: Yup.string().required("NS is required"),
});
